jQuery(document).ready(function () {
  slider();
  wowo(jQuery);
  headerMenu();
  swiperSlide();
  accordion();
  video();
  parallax();
  htmladdClass();
  split();
  videopop();
  accordionshow();
  headspace();
  customSelect();
  dateinput();

  jQuery('.card-box .card-item .img-box').hover(
    function () {
      var video = jQuery(this).find('video');
      video.get(0).play();
    },
    function () {
      var video = jQuery(this).find('video');
      video.get(0).pause();
    }
  );

  movieplay();
  loadmorephoto();

  if (jQuery('.loading-more').length > 0) {
    Fancybox.bind('[data-fancybox]', {
      compact: false,
      idle: false,
      dragToClose: false,
      commonCaption: true,

      Images: {
        zoom: false,
      },
      showClass: 'f-fadeIn',

      Toolbar: {
        absolute: false,
        display: {
          left: [],
          middle: [],
          right: ['thumbs', 'fullscreen', 'close'],
        },
      },
      tpl: {
        main: `<div class="fancybox__container" role="dialog" aria-modal="true" aria-label="{{MODAL}}" tabindex="-1">
    <div class="fancybox__backdrop"></div>  
    <div class="fancybox__toolbar"></div>
    <div class="fancybox__carousel"></div>
    <div class="fancybox__caption"></div>
    <div class="fancybox__footer"></div>
    </div>`,
      },
    });
  }


});

// var container = jQuery('.img');
// var container2 = jQuery('img');
// imagesLoaded(container, function () {
//   console.log('');
// });

jQuery(window).scroll(function () {
  wowo(jQuery);

  if (jQuery(document).scrollTop() > 30) {
    jQuery('header').addClass('sticky');
  } else {
    jQuery('header').removeClass('sticky');
  }

  parallax();
});

jQuery(window).resize(function () {
  slider();
});

function dateinput() {
  if (jQuery("#datepicker").length > 0) {
    jQuery("#datepicker").datepicker();
  }
}

function headspace() {
  jQuery('.sub-page-banner .links-box a').on('click', function () {
    var sTop = jQuery('header').outerHeight();
    jQuery('html,body').animate({ scrollTop: jQuery(this.hash).offset().top - sTop }, 800);
    return false;
  })

  jQuery('.subscribe.style-2 .links-box .btn').on('click', function () {
    var sTop = jQuery('header').outerHeight();
    jQuery('html,body').animate({ scrollTop: jQuery(this.hash).offset().top - sTop }, 800);
    return false;
  })

  jQuery('.download-card.style-2 .links-box .btn').on('click', function () {
    var sTop = jQuery('header').outerHeight();
    jQuery('html,body').animate({ scrollTop: jQuery(this.hash).offset().top - sTop }, 800);
    return false;
  })
}

function loadmorephoto() {
  var $loadImgs = jQuery('.load-img:not(.visible)');
  var batchSize = 3;
  var currentIndex = 0;

  jQuery('.loading-more .btn').on('click', function (e) {
    e.preventDefault();

    for (var i = 0; i < batchSize && currentIndex < $loadImgs.length; i++, currentIndex++) {
      jQuery($loadImgs[currentIndex]).fadeIn(300);
    }
    if (currentIndex >= $loadImgs.length) {
      jQuery(this).fadeOut(300, function () {
        jQuery(this).hide();
      });
    }
  });

}


function parallax() {
  if (jQuery(window).width() >= 991) {
    var wh = jQuery(window).height();
    var sh = jQuery(window).scrollTop();

    jQuery(".parallax").each(function () {
      var parallax_h = jQuery(this).offset().top;
      var item_h = jQuery(this).outerHeight();
      var parallax_y;
      if (sh > (parallax_h - wh) && sh < parallax_h + item_h) {
        parallax_y = 50 * (sh - (parallax_h - wh)) / (wh + item_h);
      }
      jQuery(this).css('transform', 'translateY(' + parallax_y + '%)');
    });

    jQuery(".parallax-r").each(function () {
      var parallax_h = jQuery(this).offset().top;
      var item_h = jQuery(this).outerHeight();
      var parallax_y;
      if (sh > (parallax_h - wh) && sh < parallax_h + item_h) {
        parallax_y = 50 * ((parallax_h - wh) - sh) / (wh + item_h);
      }
      jQuery(this).css('transform', 'translateY(' + parallax_y + '%)');
    });
  } else {
    jQuery('.parallax').css('transform', 'translateY(0)');
  }
}

function htmladdClass() {
  jQuery('#cart-icon-bubble').on('click', function (e) {
    e.stopPropagation();
    jQuery('html').addClass('overflow-hidden');
    jQuery('header .header-content .header-text-box-mobile').removeClass('active');
    jQuery('.burger').removeClass('active');
  });

  jQuery('.drawer__close').on('click', function (e) {
    e.stopPropagation();
    jQuery('html').removeClass('overflow-hidden');
  });

  jQuery('.drawer__inner').on('click', function (e) {
    e.stopPropagation();
  });

  jQuery('.product-form__buttons').on('click', function (e) {
    e.stopPropagation();
    jQuery('html').addClass('overflow-hidden');
  });

  jQuery('body').on('click', '.drawer__close', function (e) {
    jQuery('html').removeClass('overflow-hidden');
  });

  jQuery('.cart-drawer__overlay').on('click', function (e) {
    e.stopPropagation();
    jQuery('html').removeClass('overflow-hidden');
  });

}

function headerMenu() {
  jQuery('.burger').on('click', function (e) {
    if (jQuery(window).width() < 1201) {
      e.stopPropagation();
      jQuery(this).toggleClass('active');
      jQuery('header').toggleClass('active');
      jQuery('html').toggleClass('overflow-hidden');
      jQuery('header .header-content .header-text-box-mobile').toggleClass('active');
    }
  });

  jQuery('header .header-text-box .menu-item-has-children').on('mouseover', function (e) {
    if (jQuery(window).width() >= 1200) {
      jQuery(this).children().siblings('.sub-menu').addClass('is-show');
      jQuery(this).siblings().find('.sub-menu').removeClass('is-show');
    }
  })

  jQuery('header .header-text-box .menu-item-has-children').on('mouseleave', function (e) {
    if (jQuery(window).width() >= 1200) {
      jQuery('header .header-text-box .sub-menu').removeClass('is-show');
    }
  })


  jQuery('header .header-text-box').on('mouseleave', function (e) {
    if (jQuery(window).width() >= 1200) {
      jQuery('header .header-text-box .sub-menu').removeClass('is-show');
    }
  })

  jQuery('header .header-text-box-mobile .menu-item-has-children').on('click', function (e) {
    if (jQuery(window).width() < 1200) {
      jQuery(this).toggleClass('rotate');
      jQuery(this).children('.sub-menu').slideToggle(200);
      jQuery(this).siblings('.menu-item-has-children').children('.sub-menu').slideUp(200);
      jQuery(this).siblings('.menu-item-has-children').removeClass('rotate');
    }
  })

  // jQuery('header .sub-menu').on('click', function (e) {
  //   e.stopPropagation();
  // })

  jQuery('header .header-text-box-mobile').on('click', function (e) {
    e.stopPropagation();
  })
}

function split() {
  // jQuery('.banner .container h1').each(function () {
  //   var colors = ["#e09d6a", "#e9b46a", "#f2cd68", "#fce762"];
  //   var intThis = jQuery(this);
  //   var html = intThis.html();
  //   intThis.splitLines({ tag: '<span class=" c-summary_list_item" data-scroll><span>' });
  //   var spanText = jQuery(this).find(".c-summary_list_item");
  //   jQuery(spanText).each(function (index) {
  //     var colorIndex = index % colors.length;
  //     jQuery(this).css("color", colors[colorIndex]);
  //     jQuery(this).find("span").addClass('wowo wordUp').css("animation-delay", (index * 0.1) + "s");
  //   });
  //   jQuery(window).resize(function () {
  //     intThis.addClass('.is-resized');
  //   });
  // });
}

function wowo($) {
  jQuery('html').addClass("show-c");

  setTimeout(function () {
    var wTop = jQuery(window).scrollTop(), wHeight = jQuery(window).height(), wBottom = wTop + wHeight;
    jQuery(".wowo:not(.animated)").each(function () {
      var me = jQuery(this), meTop = me.offset().top, meHeight = me.height(), meBottom = meTop + meHeight,
        limitTop = wTop - meHeight, limitBottom = wBottom + meHeight;
      if (meTop > limitTop && meBottom < limitBottom) {
        me.addClass("animated");
        setTimeout(function () {
          me.removeClass("animated wowo");
        }, 1500);
      }
    })
  }, 100);
}

// function wowo($) {
//   setTimeout(function () {
//     //jQuery('html').addClass("show-c");

//     var wTop = jQuery(window).scrollTop(),
//       wHeight = jQuery(window).height(),
//       wBottom = wTop + wHeight;

//     jQuery("section:not(.banner) .wowo:not(.animated)").each(function () {
//       var me = jQuery(this),
//         meTop = me.offset().top,
//         meHeight = me.height(),
//         meBottom = meTop + meHeight,
//         limitTop = wTop - meHeight,
//         limitBottom = wBottom + meHeight;
//       if (meTop > limitTop && meBottom < limitBottom) {
//         if (me.hasClass('imagesLoaded-wowo')) {
//           me.parents("section").find('.imagesLoaded').imagesLoaded(function () {
//             me.addClass("animated");
//             setTimeout(function () {
//               //me.removeClass("animated wowo");
//             }, 1200);
//           });
//         } else {
//           me.addClass("animated");
//           setTimeout(function () {
//             //me.removeClass("animated wowo");
//           }, 1200);

//           if ($('.imagesLoaded-wowo').hasClass('animated')) {
//             $('.banner .container .content').addClass("animated");
//           }
//         }
//       }
//     });
//     jQuery("section:not(.banner).wowo:not(.animated)").each(function () {
//       var me = jQuery(this),
//         meTop = me.offset().top,
//         meHeight = me.height(),
//         meBottom = meTop + meHeight,
//         limitTop = wTop - meHeight,
//         limitBottom = wBottom + meHeight;
//       if (meTop > limitTop && meBottom < limitBottom) {
//         if (me.hasClass('imagesLoaded-wowo')) {
//           me.parents("section").find('.imagesLoaded').imagesLoaded(function () {
//             me.addClass("animated");
//             setTimeout(function () {
//               //me.removeClass("animated wowo");
//             }, 1200);
//           });
//         } else {
//           me.addClass("animated");
//           setTimeout(function () {
//             //me.removeClass("animated wowo");
//           }, 1200);

//           // if ($('.imagesLoaded-wowo').hasClass('animated')) {
//           //   $('.banner .container .content').addClass("animated");
//           // }
//         }
//       }
//     });
//     jQuery(".banner .wowo:not(.animated)").each(function () {
//       var me = jQuery(this),
//         meTop = me.offset().top,
//         meHeight = me.height(),
//         meBottom = meTop + meHeight,
//         limitTop = wTop - meHeight,
//         limitBottom = wBottom + meHeight;
//       if (meTop > limitTop && meBottom < limitBottom) {
//         if (me.hasClass('imagesLoaded-wowo')) {
//           me.parents("section").find('.imagesLoaded').imagesLoaded(function () {
//             me.addClass("animated");
//             setTimeout(function () {
//               //me.removeClass("animated wowo");
//             }, 1200);
//           });
//         } else {
//           // if (jQuery('.imagesLoaded-wowo').hasClass('animated')) {
//           jQuery('.banner .container .content').addClass("animated");
//           // }
//         }
//       }
//     });
//   }, 100);
// }

function slider() {


}

function accordion() {
  jQuery('.tabbed-content-content-show .accordion-content .item .item-head').on('click', function (e) {
    jQuery(this).toggleClass('active');
    jQuery(this).siblings().slideToggle(300);
    jQuery(this).parents().siblings().find('.item-body').slideUp(300);
    jQuery(this).parents().siblings().find('.item-head').removeClass('active');
  })

  jQuery('.mobile-accordion .accordion-content .item .item-head').on('click', function (e) {
    jQuery(this).toggleClass('active');
    jQuery(this).siblings().slideToggle(300);
    jQuery(this).parents().siblings().find('.item-body').slideUp(300);
    jQuery(this).parents().siblings().find('.item-head').removeClass('active');
  })
}

function swiperSlide() {
  var swiper = new Swiper(".bottom-img-slider", {
    loop: false,
    spaceBetween: 10,
    slidesPerView: 3,
    freeMode: true,
    watchSlidesProgress: true,
    breakpoints: {
      768: {
        spaceBetween: 25,
      },
    }
  });
  var swiper2 = new Swiper(".top-img-slider", {
    loop: false,
    spaceBetween: 10000,
    slidesPerView: 1,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    thumbs: {
      swiper: swiper,
    },
  });
  var swiper3 = new Swiper('.review-slider', {
    slidesPerView: 1,
    spaceBetween: 0,
    autoHeight: true,
    loop: true,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
      // dynamicBullets: true, 
      // dynamicMainBullets: 1,
    },
    breakpoints: {
      991: {
        slidesPerView: 3,
        loop: false,
        spaceBetween: 10,
      },
      768: {
        slidesPerView: 2,
        loop: false,
        spaceBetween: 10,
      },
    },
  });
}

function accordionshow() {
  jQuery('.item-head').on('click', function (e) {
    jQuery(this).toggleClass('active');
    jQuery(this).siblings().slideToggle(300);
    jQuery(this).parents().siblings().find('.item-body').slideUp(300);
    jQuery(this).parents().siblings().find('.item-head').removeClass('active');
  })
}

function movieplay() {
  var currentlyPlaying = null;

  jQuery(".my-video").on("click", function () {
    var video = jQuery(this)[0];
    var isPaused = video.paused;
    var playingBefore = currentlyPlaying;
    var pauseBtn = jQuery(this).next('.pause-btn');

    if (video === currentlyPlaying) {
      if (isPaused) {
        video.play();
        pauseBtn.addClass("play");
      } else {
        video.pause();
        pauseBtn.removeClass("play");
      }
    } else {
      if (playingBefore) {
        playingBefore.pause();
        jQuery(playingBefore).next('.pause-btn').removeClass("play");
      }

      if (isPaused) {
        video.play();
        pauseBtn.addClass("play");
      }

      currentlyPlaying = video;
    }
  });

  jQuery(".pause-btn").on("click", function () {
    var video = jQuery(this).prev('.my-video')[0];
    var isPaused = video.paused;
    var playingBefore = currentlyPlaying;

    if (video === currentlyPlaying) {
      if (isPaused) {
        video.play();
        jQuery(this).addClass("play");
      } else {
        video.pause();
        jQuery(this).removeClass("play");
      }
    } else {
      if (playingBefore) {
        playingBefore.pause();
        jQuery(playingBefore).next('.pause-btn').removeClass("play");
      }

      video.play();
      jQuery(this).addClass("play");
      currentlyPlaying = video;
    }
  });

  jQuery(".my-video").on('ended', function () {
    currentlyPlaying = null;
    jQuery(this).next('.pause-btn').removeClass("play");
  });
}

function videopop() {
  jQuery('body').on('click', '.media-text .media-box .pop-video', function (event) {
    jQuery('.video-pop').fadeIn(300);
    jQuery('html').addClass('overflow-hidden');
    event.stopPropagation();
    event.preventDefault();

    if (jQuery('.pop-video').hasClass('is-video') && jQuery('.media-text .media-box img').hasClass('is-video')) {
      var videoSrc = jQuery('.pop-iframe div').data('video');
      console.log(videoSrc)
      jQuery('.video-box').html('<video controls src="' + videoSrc + '"></video>');
      video();
    } else {
      var popiframe = jQuery('.pop-iframe').html();
      jQuery('.video-box').html(popiframe);
    }
  })

  jQuery('body').on('click', '.media-text .media-box img', function (event) {
    jQuery('.video-pop').fadeIn(300);
    jQuery('html').addClass('overflow-hidden');
    event.stopPropagation();
    event.preventDefault();

    if (jQuery('.pop-video').hasClass('is-video') && jQuery('.media-text .media-box img').hasClass('is-video')) {
      var videoSrc = jQuery('.pop-iframe div').data('video');
      console.log(videoSrc)
      jQuery('.video-box').html('<video controls src="' + videoSrc + '"></video>');
      video();
    } else {
      var popiframe = jQuery('.pop-iframe').html();
      jQuery('.video-box').html(popiframe);
    }
  })

  jQuery('body').on('click', '.video-pop .video-box', function (event) {
    event.stopPropagation();
  })

  jQuery('body').on('click', function () {
    jQuery('.video-pop').fadeOut(300).removeClass('is-video');
    jQuery('.video-box').empty();
    jQuery('html').removeClass('overflow-hidden');
  })
}

function customSelect() {
  jQuery('body').on('click', '.is-select input', function (e) {
    e.stopPropagation();
    jQuery(this).parents('.is-select').toggleClass('open');
    jQuery(this).parents('.is-select').find('ul').slideToggle(200);
  })

  jQuery('.is-select ul li a').click(function () {
    jQuery(this).parents('.is-select').removeClass('open');
    jQuery(this).parents('.is-select').find('ul').slideUp(200);
    var value = jQuery(this).text();
    jQuery(this).parents('.is-select').find('input').val(value);
  });

  jQuery('body').click(function () {
    jQuery('.is-select').removeClass('open');
    jQuery('.is-select').find('ul').slideUp(200);
  });
}

function video() {
  var videoElements = document.querySelectorAll('video');
  videoElements.forEach(function (videoElement) {
    var videoSrc = videoElement.getAttribute('src');
    if (videoSrc && videoSrc.endsWith('.mp4')) {
    } else {
      var hls = new Hls();
      hls.loadSource(videoSrc);
      hls.attachMedia(videoElement);
    }
  });
}

function isEmail(email) {
  var reg = /^[0-9a-zA-Z_.-]+[@][0-9a-zA-Z_.-]+([.][a-zA-Z]+){1,2}$/;
  if (reg.test(email)) {
    return true;
  } else {
    return false;
  }
}

function appHeight() {
  const doc = document.documentElement;
  doc.style.setProperty('--vh', (window.innerHeight * .01) + 'px');
}

window.addEventListener('resize', appHeight);
appHeight();